'use client';

import React from 'react';
import { twMerge } from 'tailwind-merge';

interface BoxProps extends React.HTMLAttributes<HTMLElement> {
  ref?: React.Ref<HTMLElement>;
  children?: React.ReactNode;
  component?: React.ElementType;
  className?: string;
}

export const Box: React.FC<BoxProps> = ({
  children,
  component: Component = 'div',
  className = '',
  ...other
}) => {
  const boxClasses = twMerge('', className);

  return (
    <Component className={boxClasses} {...other}>
      {children}
    </Component>
  );
};

export default Box;
